import React from "react";
import { useLanguageContext } from "./../../store/LanguageContext";

export default function   LanguageHandler() {
  const { language, changeLanguage } = useLanguageContext();

  return (
    <select
      style={{ width: "110px" }}
      value={language}
      onChange={(e) => changeLanguage(e.target.value)}
    >
      <option value="bangla">বাংলা</option>
      <option value="en">En- English</option>

      {/* <option value="it">It- Italian</option>
      <option value="fr">Fr- France</option> */}
    </select>
  );
}
